import { useEffect } from 'react';
import { useAtlasStore } from '@/stores/atlasStore';
import { fetchOrder, fetchCogStatistics, fetchCogStatisticsClipped, fetchCogStatisticsClippedRGB, fetchTileJSON, buildMdtTileUrl, buildHillshadeTileUrl, buildHillshadeHypsoTileUrl, buildHillshadeHypsoLocalTileUrl, buildSlopeTileUrl, buildAspectTileUrl, buildGeomorphonsTileUrl, buildErosionRiskTileUrl, buildWindExpositionTileUrl, buildFlowAccTileUrl } from '@/services/api';
import { MapView2D } from '@/components/MapView2D';
import { ViewToggle } from '@/components/ViewToggle';
import { Toolbar } from '@/components/Toolbar';
import { LegendStrip } from '@/components/LegendStrip';

function App() {
  const viewMode = useAtlasStore((s) => s.viewMode);
  const loading = useAtlasStore((s) => s.loading);
  const error = useAtlasStore((s) => s.error);
  const setOrderPolygon = useAtlasStore((s) => s.setOrderPolygon);
  const setOrderBounds = useAtlasStore((s) => s.setOrderBounds);
  const setLoading = useAtlasStore((s) => s.setLoading);
  const setError = useAtlasStore((s) => s.setError);
  const setMdtTileUrl = useAtlasStore((s) => s.setMdtTileUrl);
  const setMdtRescale = useAtlasStore((s) => s.setMdtRescale);
  const setMdtZoomRange = useAtlasStore((s) => s.setMdtZoomRange);
  const setMdtLocalTileUrl = useAtlasStore((s) => s.setMdtLocalTileUrl);
  const setMdtLocalZoomRange = useAtlasStore((s) => s.setMdtLocalZoomRange);
  const setMdtDgtTileUrl = useAtlasStore((s) => s.setMdtDgtTileUrl);
  const setMdtDgtRescale = useAtlasStore((s) => s.setMdtDgtRescale);
  const setMdtDgtZoomRange = useAtlasStore((s) => s.setMdtDgtZoomRange);
  const setMdtDgtLocalTileUrl = useAtlasStore((s) => s.setMdtDgtLocalTileUrl);
  const setMdtDgtLocalZoomRange = useAtlasStore((s) => s.setMdtDgtLocalZoomRange);
  const setHillshadeTileUrl = useAtlasStore((s) => s.setHillshadeTileUrl);
  const setHillshadeZoomRange = useAtlasStore((s) => s.setHillshadeZoomRange);
  const setHillshadeLocalTileUrl = useAtlasStore((s) => s.setHillshadeLocalTileUrl);
  const setHillshadeLocalZoomRange = useAtlasStore((s) => s.setHillshadeLocalZoomRange);
  const setHillshadeDgtTileUrl = useAtlasStore((s) => s.setHillshadeDgtTileUrl);
  const setHillshadeDgtZoomRange = useAtlasStore((s) => s.setHillshadeDgtZoomRange);
  const setHillshadeDgtLocalTileUrl = useAtlasStore((s) => s.setHillshadeDgtLocalTileUrl);
  const setHillshadeDgtLocalZoomRange = useAtlasStore((s) => s.setHillshadeDgtLocalZoomRange);
  const setHillshadeHypsoTileUrl = useAtlasStore((s) => s.setHillshadeHypsoTileUrl);
  const setHillshadeHypsoZoomRange = useAtlasStore((s) => s.setHillshadeHypsoZoomRange);
  const setHillshadeHypsoLocalTileUrl = useAtlasStore((s) => s.setHillshadeHypsoLocalTileUrl);
  const setHillshadeHypsoLocalZoomRange = useAtlasStore((s) => s.setHillshadeHypsoLocalZoomRange);
  const setHillshadeHypsoDgtTileUrl = useAtlasStore((s) => s.setHillshadeHypsoDgtTileUrl);
  const setHillshadeHypsoDgtZoomRange = useAtlasStore((s) => s.setHillshadeHypsoDgtZoomRange);
  const setHillshadeHypsoDgtLocalTileUrl = useAtlasStore((s) => s.setHillshadeHypsoDgtLocalTileUrl);
  const setHillshadeHypsoDgtLocalZoomRange = useAtlasStore((s) => s.setHillshadeHypsoDgtLocalZoomRange);
  const setContoursTileUrl = useAtlasStore((s) => s.setContoursTileUrl);
  const setContoursSourceLayer = useAtlasStore((s) => s.setContoursSourceLayer);
  const setContoursItemId = useAtlasStore((s) => s.setContoursItemId);
  const setContoursDgtTileUrl = useAtlasStore((s) => s.setContoursDgtTileUrl);
  const setContoursDgtSourceLayer = useAtlasStore((s) => s.setContoursDgtSourceLayer);
  const setContoursDgtItemId = useAtlasStore((s) => s.setContoursDgtItemId);
  const setSlopeTileUrl = useAtlasStore((s) => s.setSlopeTileUrl);
  const setSlopeZoomRange = useAtlasStore((s) => s.setSlopeZoomRange);
  const setAspectTileUrl = useAtlasStore((s) => s.setAspectTileUrl);
  const setAspectZoomRange = useAtlasStore((s) => s.setAspectZoomRange);
  const setGeomorphonsTileUrl = useAtlasStore((s) => s.setGeomorphonsTileUrl);
  const setErosionRiskTileUrl = useAtlasStore((s) => s.setErosionRiskTileUrl);
  const setErosionRiskZoomRange = useAtlasStore((s) => s.setErosionRiskZoomRange);
  const setGeomorphonsZoomRange = useAtlasStore((s) => s.setGeomorphonsZoomRange);
  const setWindExpositionTileUrl = useAtlasStore((s) => s.setWindExpositionTileUrl);
  const setWindExpositionZoomRange = useAtlasStore((s) => s.setWindExpositionZoomRange);
  const setWindHillshadeTileUrl = useAtlasStore((s) => s.setWindHillshadeTileUrl);
  const setWindHillshadeZoomRange = useAtlasStore((s) => s.setWindHillshadeZoomRange);
  const setStreamsTileUrl = useAtlasStore((s) => s.setStreamsTileUrl);
  const setStreamsSourceLayer = useAtlasStore((s) => s.setStreamsSourceLayer);
  const setStreamsItemId = useAtlasStore((s) => s.setStreamsItemId);
  const setRidgesTileUrl = useAtlasStore((s) => s.setRidgesTileUrl);
  const setRidgesSourceLayer = useAtlasStore((s) => s.setRidgesSourceLayer);
  const setRidgesItemId = useAtlasStore((s) => s.setRidgesItemId);
  const setBasinsTileUrl = useAtlasStore((s) => s.setBasinsTileUrl);
  const setBasinsSourceLayer = useAtlasStore((s) => s.setBasinsSourceLayer);
  const setBasinsItemId = useAtlasStore((s) => s.setBasinsItemId);
  const setKeypointsTileUrl = useAtlasStore((s) => s.setKeypointsTileUrl);
  const setKeypointsSourceLayer = useAtlasStore((s) => s.setKeypointsSourceLayer);
  const setKeypointsItemId = useAtlasStore((s) => s.setKeypointsItemId);
  const setPrimaryValleysTileUrl = useAtlasStore((s) => s.setPrimaryValleysTileUrl);
  const setPrimaryValleysSourceLayer = useAtlasStore((s) => s.setPrimaryValleysSourceLayer);
  const setPrimaryValleysItemId = useAtlasStore((s) => s.setPrimaryValleysItemId);
  const setPrimaryRidgesTileUrl = useAtlasStore((s) => s.setPrimaryRidgesTileUrl);
  const setPrimaryRidgesSourceLayer = useAtlasStore((s) => s.setPrimaryRidgesSourceLayer);
  const setPrimaryRidgesItemId = useAtlasStore((s) => s.setPrimaryRidgesItemId);
  const setFloodZonesTileUrl = useAtlasStore((s) => s.setFloodZonesTileUrl);
  const setFloodZonesSourceLayer = useAtlasStore((s) => s.setFloodZonesSourceLayer);
  const setFloodZonesItemId = useAtlasStore((s) => s.setFloodZonesItemId);
  const setFlowAccTileUrl = useAtlasStore((s) => s.setFlowAccTileUrl);
  const setFlowAccZoomRange = useAtlasStore((s) => s.setFlowAccZoomRange);

  // Parse order ID from URL
  const orderId = new URLSearchParams(window.location.search).get('order');

  // Fetch order on mount
  useEffect(() => {
    if (!orderId) {
      setError('Parametro "order" em falta no URL');
      return;
    }

    setLoading(true);
    setError(null);

    fetchOrder(orderId)
      .then(async (result) => {
        if (!result) {
          setError('Pedido nao encontrado');
          return;
        }
        setOrderPolygon(result.polygon);
        setOrderBounds(result.bounds);

        // Build MDT layer if available
        if (result.mdtTileUrl) {
          const stats = await fetchCogStatistics(result.mdtTileUrl);
          const min = stats ? Math.floor(stats.min - 10) : 0;
          const max = stats ? Math.ceil(stats.max + 10) : 500;
          const rescale = `${min},${max}`;
          const tileUrl = buildMdtTileUrl(result.mdtTileUrl, rescale);
          setMdtTileUrl(tileUrl);
          setMdtRescale(rescale);
          console.log(`MDT layer ready: rescale ${rescale}`);

          // Fetch zoom range for proper tile loading
          const zoomRange = await fetchTileJSON(result.mdtTileUrl, rescale);
          if (zoomRange) {
            setMdtZoomRange(zoomRange);
            console.log(`MDT zoom range: ${zoomRange.minzoom}-${zoomRange.maxzoom}`);
          }
        }

        // Build MDT Local layer (polygon-clipped rescale for detail within boundary)
        if (result.mdtTileUrl && result.polygon) {
          const clippedStats = await fetchCogStatisticsClipped(result.mdtTileUrl, result.polygon);
          if (clippedStats) {
            const localMin = Math.floor(clippedStats.min - 5);
            const localMax = Math.ceil(clippedStats.max + 5);
            const localRescale = `${localMin},${localMax}`;
            const localTileUrl = buildMdtTileUrl(result.mdtTileUrl, localRescale);
            setMdtLocalTileUrl(localTileUrl);
            console.log(`MDT Local layer ready: rescale ${localRescale} (polygon range)`);

            const zoomRange = await fetchTileJSON(result.mdtTileUrl, localRescale);
            if (zoomRange) {
              setMdtLocalZoomRange(zoomRange);
            }
          }
        }

        // Build MDT DGT layer if available (LOLA 50cm LiDAR)
        if (result.mdtDgtTileUrl) {
          const stats = await fetchCogStatistics(result.mdtDgtTileUrl);
          const min = stats ? Math.floor(stats.min - 10) : 0;
          const max = stats ? Math.ceil(stats.max + 10) : 500;
          const rescale = `${min},${max}`;
          const tileUrl = buildMdtTileUrl(result.mdtDgtTileUrl, rescale);
          setMdtDgtTileUrl(tileUrl);
          setMdtDgtRescale(rescale);
          console.log(`MDT DGT layer ready: rescale ${rescale}`);

          const zoomRange = await fetchTileJSON(result.mdtDgtTileUrl, rescale);
          if (zoomRange) {
            setMdtDgtZoomRange(zoomRange);
            console.log(`MDT DGT zoom range: ${zoomRange.minzoom}-${zoomRange.maxzoom}`);
          }
        }

        // Build MDT DGT Local layer (polygon-clipped rescale)
        if (result.mdtDgtTileUrl && result.polygon) {
          const clippedStats = await fetchCogStatisticsClipped(result.mdtDgtTileUrl, result.polygon);
          if (clippedStats) {
            const localMin = Math.floor(clippedStats.min - 5);
            const localMax = Math.ceil(clippedStats.max + 5);
            const localRescale = `${localMin},${localMax}`;
            const localTileUrl = buildMdtTileUrl(result.mdtDgtTileUrl, localRescale);
            setMdtDgtLocalTileUrl(localTileUrl);
            console.log(`MDT DGT Local layer ready: rescale ${localRescale} (polygon range)`);

            const zoomRange = await fetchTileJSON(result.mdtDgtTileUrl, localRescale);
            if (zoomRange) {
              setMdtDgtLocalZoomRange(zoomRange);
            }
          }
        }

        // Build Hillshade layer if available (B&W grayscale, rescale 0-255)
        if (result.hillshadeTileUrl) {
          const rescale = '0,255';
          const tileUrl = buildHillshadeTileUrl(result.hillshadeTileUrl, rescale);
          setHillshadeTileUrl(tileUrl);
          console.log('Hillshade layer ready');

          const zoomRange = await fetchTileJSON(result.hillshadeTileUrl, rescale);
          if (zoomRange) {
            setHillshadeZoomRange(zoomRange);
            console.log(`Hillshade zoom range: ${zoomRange.minzoom}-${zoomRange.maxzoom}`);
          }
        }

        // Build Hillshade Local layer (polygon-clipped rescale for detail within boundary)
        if (result.hillshadeTileUrl && result.polygon) {
          const clippedStats = await fetchCogStatisticsClipped(result.hillshadeTileUrl, result.polygon);
          if (clippedStats) {
            const localMin = Math.floor(clippedStats.min - 5);
            const localMax = Math.ceil(clippedStats.max + 5);
            const localRescale = `${localMin},${localMax}`;
            const localTileUrl = buildHillshadeTileUrl(result.hillshadeTileUrl, localRescale);
            setHillshadeLocalTileUrl(localTileUrl);
            console.log(`Hillshade Local layer ready: rescale ${localRescale} (polygon range)`);

            const zoomRange = await fetchTileJSON(result.hillshadeTileUrl, localRescale);
            if (zoomRange) {
              setHillshadeLocalZoomRange(zoomRange);
            }
          }
        }

        // Build Hillshade Hypsometric layer if available (3-band RGB, no rescale/colormap)
        if (result.hillshadeHypsoTileUrl) {
          const tileUrl = buildHillshadeHypsoTileUrl(result.hillshadeHypsoTileUrl);
          setHillshadeHypsoTileUrl(tileUrl);
          console.log('Hillshade Hypsometric layer ready');

          const zoomRange = await fetchTileJSON(result.hillshadeHypsoTileUrl, '0,255');
          if (zoomRange) {
            setHillshadeHypsoZoomRange(zoomRange);
            console.log(`Hillshade Hypsometric zoom range: ${zoomRange.minzoom}-${zoomRange.maxzoom}`);
          }
        }

        // Build Hillshade Hypsometric Local layer (polygon-clipped per-band RGB rescale)
        if (result.hillshadeHypsoTileUrl && result.polygon) {
          const rgbStats = await fetchCogStatisticsClippedRGB(result.hillshadeHypsoTileUrl, result.polygon);
          if (rgbStats) {
            const pad = 5;
            const rR = `${Math.max(0, Math.floor(rgbStats.b1.min - pad))},${Math.min(255, Math.ceil(rgbStats.b1.max + pad))}`;
            const rG = `${Math.max(0, Math.floor(rgbStats.b2.min - pad))},${Math.min(255, Math.ceil(rgbStats.b2.max + pad))}`;
            const rB = `${Math.max(0, Math.floor(rgbStats.b3.min - pad))},${Math.min(255, Math.ceil(rgbStats.b3.max + pad))}`;
            const localTileUrl = buildHillshadeHypsoLocalTileUrl(result.hillshadeHypsoTileUrl, rR, rG, rB);
            setHillshadeHypsoLocalTileUrl(localTileUrl);
            console.log(`Hillshade Hypsometric Local ready: R=${rR} G=${rG} B=${rB}`);

            const zoomRange = await fetchTileJSON(result.hillshadeHypsoTileUrl, '0,255');
            if (zoomRange) {
              setHillshadeHypsoLocalZoomRange(zoomRange);
            }
          }
        }
        // Build Hillshade DGT layer (B&W from LOLA 50cm, gamma 3)
        if (result.hillshadeDgtTileUrl) {
          const rescale = '0,255';
          const tileUrl = buildHillshadeTileUrl(result.hillshadeDgtTileUrl, rescale);
          setHillshadeDgtTileUrl(tileUrl);
          console.log('Hillshade DGT layer ready');
          const zoomRange = await fetchTileJSON(result.hillshadeDgtTileUrl, rescale);
          if (zoomRange) setHillshadeDgtZoomRange(zoomRange);
        }

        // Build Hillshade DGT Local (polygon-clipped rescale)
        if (result.hillshadeDgtTileUrl && result.polygon) {
          const clippedStats = await fetchCogStatisticsClipped(result.hillshadeDgtTileUrl, result.polygon);
          if (clippedStats) {
            const localRescale = `${Math.floor(clippedStats.min - 5)},${Math.ceil(clippedStats.max + 5)}`;
            setHillshadeDgtLocalTileUrl(buildHillshadeTileUrl(result.hillshadeDgtTileUrl, localRescale));
            console.log(`Hillshade DGT Local ready: rescale ${localRescale}`);
            const zoomRange = await fetchTileJSON(result.hillshadeDgtTileUrl, localRescale);
            if (zoomRange) setHillshadeDgtLocalZoomRange(zoomRange);
          }
        }

        // Build Hillshade Hypsometric DGT layer (3-band RGB from LOLA 50cm)
        if (result.hillshadeHypsoDgtTileUrl) {
          const tileUrl = buildHillshadeHypsoTileUrl(result.hillshadeHypsoDgtTileUrl);
          setHillshadeHypsoDgtTileUrl(tileUrl);
          console.log('Hillshade Hypsometric DGT layer ready');
          const zoomRange = await fetchTileJSON(result.hillshadeHypsoDgtTileUrl, '0,255');
          if (zoomRange) setHillshadeHypsoDgtZoomRange(zoomRange);
        }

        // Build Hillshade Hypsometric DGT Local (polygon-clipped per-band RGB)
        if (result.hillshadeHypsoDgtTileUrl && result.polygon) {
          const rgbStats = await fetchCogStatisticsClippedRGB(result.hillshadeHypsoDgtTileUrl, result.polygon);
          if (rgbStats) {
            const pad = 5;
            const rR = `${Math.max(0, Math.floor(rgbStats.b1.min - pad))},${Math.min(255, Math.ceil(rgbStats.b1.max + pad))}`;
            const rG = `${Math.max(0, Math.floor(rgbStats.b2.min - pad))},${Math.min(255, Math.ceil(rgbStats.b2.max + pad))}`;
            const rB = `${Math.max(0, Math.floor(rgbStats.b3.min - pad))},${Math.min(255, Math.ceil(rgbStats.b3.max + pad))}`;
            setHillshadeHypsoDgtLocalTileUrl(buildHillshadeHypsoLocalTileUrl(result.hillshadeHypsoDgtTileUrl, rR, rG, rB));
            console.log(`Hillshade Hypsometric DGT Local ready: R=${rR} G=${rG} B=${rB}`);
            const zoomRange = await fetchTileJSON(result.hillshadeHypsoDgtTileUrl, '0,255');
            if (zoomRange) setHillshadeHypsoDgtLocalZoomRange(zoomRange);
          }
        }

        // Set contours AWS tile URL if available (vector tiles via Martin)
        if (result.contoursTileUrl) {
          setContoursTileUrl(result.contoursTileUrl);
          setContoursSourceLayer(result.contoursSourceLayer);
          setContoursItemId(result.contoursItemId);
          console.log(`Contours AWS layer ready: ${result.contoursSourceLayer}`);
        }

        // Set contours DGT tile URL if available (vector tiles via Martin — LOLA 50cm/2m)
        if (result.contoursDgtTileUrl) {
          setContoursDgtTileUrl(result.contoursDgtTileUrl);
          setContoursDgtSourceLayer(result.contoursDgtSourceLayer);
          setContoursDgtItemId(result.contoursDgtItemId);
          console.log(`Contours DGT layer ready: ${result.contoursDgtSourceLayer}`);
        }

        // Set slope (Declives) tile URL if available
        if (result.slopeCogPath) {
          const slopeTileUrl = buildSlopeTileUrl(result.slopeCogPath);
          setSlopeTileUrl(slopeTileUrl);
          // Fetch zoom range
          fetchTileJSON(result.slopeCogPath, '0,45').then((zr) => {
            if (zr) {
              setSlopeZoomRange(zr);
              console.log(`Slope zoom range: ${zr.minzoom}-${zr.maxzoom}`);
            }
          });
          console.log('Slope layer ready');
        }

        // Set aspect (Exposição Solar) tile URL if available
        if (result.aspectCogPath) {
          const aspectTileUrl = buildAspectTileUrl(result.aspectCogPath);
          setAspectTileUrl(aspectTileUrl);
          fetchTileJSON(result.aspectCogPath, '0,360').then((zr) => {
            if (zr) {
              setAspectZoomRange(zr);
              console.log(`Aspect zoom range: ${zr.minzoom}-${zr.maxzoom}`);
            }
          });
          console.log('Aspect layer ready');
        }

        // Set geomorphons tile URL if available
        if (result.geomorphonsCogPath) {
          const geomorphonsTileUrl = buildGeomorphonsTileUrl(result.geomorphonsCogPath);
          setGeomorphonsTileUrl(geomorphonsTileUrl);
          fetchTileJSON(result.geomorphonsCogPath, '1,10').then((zr) => {
            if (zr) {
              setGeomorphonsZoomRange(zr);
              console.log(`Geomorphons zoom range: ${zr.minzoom}-${zr.maxzoom}`);
            }
          });
          console.log('Geomorphons layer ready');
        }

        // Set erosion risk tile URL if available (dynamic rescale from stats)
        if (result.erosionRiskCogPath) {
          const eroStats = await fetchCogStatistics(result.erosionRiskCogPath);
          const eMin = 0;
          const eMax = eroStats ? Math.ceil(eroStats.max) : 50;
          const eroRescale = `${eMin},${eMax}`;
          const erosionRiskTileUrl = buildErosionRiskTileUrl(result.erosionRiskCogPath, eroRescale);
          setErosionRiskTileUrl(erosionRiskTileUrl);
          fetchTileJSON(result.erosionRiskCogPath, eroRescale).then((zr) => {
            if (zr) {
              setErosionRiskZoomRange(zr);
              console.log(`Erosion Risk zoom range: ${zr.minzoom}-${zr.maxzoom}`);
            }
          });
          console.log(`Erosion Risk layer ready: rescale ${eroRescale}`);
        }

        // Set wind exposition tile URL if available
        if (result.windExpositionCogPath) {
          const windTileUrl = buildWindExpositionTileUrl(result.windExpositionCogPath);
          setWindExpositionTileUrl(windTileUrl);
          fetchTileJSON(result.windExpositionCogPath, '0.7,1.3').then((zr) => {
            if (zr) {
              setWindExpositionZoomRange(zr);
              console.log(`Wind Exposition zoom range: ${zr.minzoom}-${zr.maxzoom}`);
            }
          });
          console.log('Wind Exposition layer ready');
        }

        // Set companion hillshade gamma1 for wind exposition underlay
        if (result.windHillshadeCogPath) {
          const rescale = '0,255';
          const hillTileUrl = buildHillshadeTileUrl(result.windHillshadeCogPath, rescale);
          setWindHillshadeTileUrl(hillTileUrl);
          fetchTileJSON(result.windHillshadeCogPath, rescale).then((zr) => {
            if (zr) {
              setWindHillshadeZoomRange(zr);
            }
          });
          console.log('Wind Hillshade gamma1 layer ready');
        }

        // Set streams tile URL if available (vector tiles via Martin)
        if (result.streamsTileUrl) {
          setStreamsTileUrl(result.streamsTileUrl);
          setStreamsSourceLayer(result.streamsSourceLayer);
          setStreamsItemId(result.streamsItemId);
          console.log(`Streams layer ready: ${result.streamsSourceLayer}`);
        }

        // Set ridges tile URL if available (vector tiles via Martin)
        if (result.ridgesTileUrl) {
          setRidgesTileUrl(result.ridgesTileUrl);
          setRidgesSourceLayer(result.ridgesSourceLayer);
          setRidgesItemId(result.ridgesItemId);
          console.log(`Ridges layer ready: ${result.ridgesSourceLayer}`);
        }

        // Set basins tile URL if available (vector tiles via Martin)
        if (result.basinsTileUrl) {
          setBasinsTileUrl(result.basinsTileUrl);
          setBasinsSourceLayer(result.basinsSourceLayer);
          setBasinsItemId(result.basinsItemId);
          console.log(`Basins layer ready: ${result.basinsSourceLayer}`);
        }

        // Set keypoints tile URL if available (vector tiles via Martin)
        if (result.keypointsTileUrl) {
          setKeypointsTileUrl(result.keypointsTileUrl);
          setKeypointsSourceLayer(result.keypointsSourceLayer);
          setKeypointsItemId(result.keypointsItemId);
          console.log(`Keypoints layer ready: ${result.keypointsSourceLayer}`);
        }

        // Set primary valleys tile URL if available (vector tiles via Martin)
        if (result.primaryValleysTileUrl) {
          setPrimaryValleysTileUrl(result.primaryValleysTileUrl);
          setPrimaryValleysSourceLayer(result.primaryValleysSourceLayer);
          setPrimaryValleysItemId(result.primaryValleysItemId);
          console.log(`Primary valleys layer ready: ${result.primaryValleysSourceLayer}`);
        }

        // Set primary ridges tile URL if available (vector tiles via Martin)
        if (result.primaryRidgesTileUrl) {
          setPrimaryRidgesTileUrl(result.primaryRidgesTileUrl);
          setPrimaryRidgesSourceLayer(result.primaryRidgesSourceLayer);
          setPrimaryRidgesItemId(result.primaryRidgesItemId);
          console.log(`Primary ridges layer ready: ${result.primaryRidgesSourceLayer}`);
        }

        // Set flood zones tile URL if available (vector tiles via Martin)
        if (result.floodZonesTileUrl) {
          setFloodZonesTileUrl(result.floodZonesTileUrl);
          setFloodZonesSourceLayer(result.floodZonesSourceLayer);
          setFloodZonesItemId(result.floodZonesItemId);
          console.log(`Flood zones layer ready: ${result.floodZonesSourceLayer}`);
        }

        // Set flow accumulation tile URL if available (dynamic rescale from stats)
        if (result.flowAccCogPath) {
          const flowStats = await fetchCogStatistics(result.flowAccCogPath);
          const fMin = flowStats ? Math.floor(flowStats.min * 10) / 10 : 0;
          const fMax = flowStats ? Math.ceil(flowStats.max * 10) / 10 : 6;
          const flowRescale = `${fMin},${fMax}`;
          const flowAccTileUrl = buildFlowAccTileUrl(result.flowAccCogPath, flowRescale);
          setFlowAccTileUrl(flowAccTileUrl);
          console.log(`Flow Accumulation layer ready: rescale ${flowRescale}`);
          fetchTileJSON(result.flowAccCogPath, flowRescale).then((zr) => {
            if (zr) {
              setFlowAccZoomRange(zr);
              console.log(`Flow Acc zoom range: ${zr.minzoom}-${zr.maxzoom}`);
            }
          });
        }
      })
      .catch((err) => {
        setError(`Erro ao carregar pedido: ${err.message}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [orderId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Camera sync on mode switch — deactivated (3D disabled)

  return (
    <div className="relative w-full h-full">
      {/* 2D Map — always mounted, hidden via CSS when not active */}
      <div style={{ display: viewMode === '2d' ? 'block' : 'none', width: '100%', height: '100%' }}>
        <MapView2D />
      </div>

      {/* 3D Map — deactivated */}

      {/* Controls overlay */}
      <div className="absolute top-4 left-4 z-10 flex flex-col gap-2">
        <ViewToggle />
        <Toolbar />
      </div>

      {/* Legend strip — bottom-right, auto-shows for active layers */}
      <LegendStrip />

      {/* Loading spinner */}
      {loading && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/50">
          <div className="bg-schist rounded-lg p-6 shadow-xl shadow-black/30 flex flex-col items-center gap-3">
            <div className="animate-spin rounded-full h-10 w-10 border-4 border-clay/30 border-t-terracotta" />
            <p className="text-sm text-clay">A carregar pedido...</p>
          </div>
        </div>
      )}

      {/* Error message */}
      {error && !loading && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-black/50">
          <div className="bg-schist rounded-lg p-6 shadow-xl shadow-black/30 max-w-sm">
            <p className="text-terracotta font-medium mb-1">Erro</p>
            <p className="text-sm text-clay">{error}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
